<ng-container *transloco="let t;">
<form (submit)="onSubmit()" novalidate *ngIf="element !== null">
    <div class="p-grid">
      <div class="p-col-6">
          <h2>{{ t('common.labels.visibility') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
        <button withRight="admin.element.edit" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <div *ngIf="permissions.length > 0">

      <p-table *ngIf="inEdit !== true" [value]="permissions">
          <ng-template pTemplate="header">
              <tr>
                  <th>{{ t('common.labels.exercisepart') }}</th>
                  <th>{{ t('common.labels.visibility') }}</th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-permission>
              <tr>
                  <td><p>{{ permission.name }}</p></td>
                  <td>
                      <fa-icon *ngIf="permission.moderator === true" [icon]="faUserTie" class="p-mr-2" pTooltip="{{ t('common.labels.moderator') }}"></fa-icon>
                      <fa-icon *ngIf="permission.candidate === true" [icon]="faStreetView" class="p-ml-2 p-mr-2" pTooltip="{{ t('common.labels.candidate') }}"></fa-icon>
                      <fa-icon *ngIf="permission.observer === true" [icon]="faUsers" class="p-ml-2" pTooltip="{{ t('common.labels.observer') }}"></fa-icon>
                  </td>
              </tr>
          </ng-template>
      </p-table>

      <p-table *ngIf="inEdit === true" [value]="form.get('permissions')['controls']">
          <ng-template pTemplate="header">
              <tr>
                  <th>{{ t('common.labels.exercisepart') }}</th>
                  <th>{{ t('common.labels.visibility') }}</th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-control>
            <tr>
                <td><p>{{ control.get('name').value }}</p></td>
                <td>
                  <div class="p-grid">
                    <div class="p-col-4">
                      <div class="p-field-checkbox p-mb-0">
                        <p-checkbox [formControl]="control.get('moderator')" binary="true" (click)="setFormFields()"></p-checkbox>
                        <label for="description"><fa-icon [icon]="faUserTie" pTooltip="{{ t('common.labels.moderator') }}"></fa-icon></label>
                      </div>
                    </div>
                    <div class="p-col-4">
                      <div class="p-field-checkbox p-mb-0">
                        <p-checkbox [formControl]="control.get('candidate')" binary="true" (click)="setFormFields()"></p-checkbox>
                        <label for="description"><fa-icon [icon]="faStreetView" pTooltip="{{ t('common.labels.candidate') }}"></fa-icon></label>
                      </div>
                    </div>
                    <div class="p-col-4">
                      <div class="p-field-checkbox p-mb-0">
                        <p-checkbox [formControl]="control.get('observer')" binary="true" (click)="setFormFields()"></p-checkbox>
                        <label for="description"><fa-icon [icon]="faUsers" pTooltip="{{ t('common.labels.observer') }}"></fa-icon></label>
                      </div>
                    </div>
                  </div>
                </td>
            </tr>
          </ng-template>
      </p-table>

    </div>

  </form>

  <app-inherit-dialog
    [title]="t('common.labels.save')"
    [mode]="'exercise'"
    [(visible)]="inheritVisible"
    (okClicked)="savePermissions($event)"
  ></app-inherit-dialog>

</ng-container>
